export default "__VITE_ASSET__CcvqsJDF__"